import { SearchFilterTag } from '@/components';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { getSearchKeyword } from '@/features/search/_utils/projects-search';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const TextSearchTag: FC = () => {
  const { control, setValue } = useFormContext<SharedSearchFormType>();
  const searchKeyword = useWatch({
    control,
    name: 'q',
  });
  const isSearchTargetProjectName = useWatch({
    control,
    name: 'isSearchTargetProjectName',
  });

  const value = getSearchKeyword(searchKeyword, isSearchTargetProjectName);
  if (!value) {
    return null;
  }

  return (
    <SearchFilterTag
      label={value}
      closable={true}
      onClose={() => {
        setValue('q', null);
        setValue('isSearchTargetProjectName', false);
      }}
    />
  );
};
